<template>
  <v-row
    class="ml-6 permission-row item-border-bottom"
  >
    <v-col
      cols="12"
      class="pa-0"
    >
      <v-row>
        <sn-checkbox
          :input-value="permission.value"
          :label="permission.display_name"
          :disabled="viewOnly || permission.view_only"
          class="my-3"
          simple
          @change="handleChange(permission)"
        />
      </v-row>
    </v-col>
    <template v-if="permission.value && permission.children.length > 0">
      <v-col
        v-for="(child, index) in permission.children"
        :key="index"
        class="ml-12 pa-0"
        cols="12"
      >
        <v-row>
          <sn-checkbox
            :input-value="child.value"
            :label="child.display_name"
            :disabled="viewOnly"
            class="my-3"
            simple
            @change="handleChange(child)"
          />
        </v-row>
      </v-col>
    </template>
  </v-row>
</template>

<script>

export default {
  name: 'PermissionRow',
  props: {
    permission: {
      type: Object,
      required: true
    },
    nonDefaultPermissions: {
      type: Array,
      required: false,
      default: () => []
    },
    viewOnly: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  methods: {
    handleChange (permission) {
      const changedPermissions = []
      permission.value = !permission.value
      changedPermissions.push(permission.key)
      if (permission.children.length > 0) {
        permission.children.forEach(child => {
          if (child.value !== permission.value) {
            child.value = permission.value
            changedPermissions.push(child.key)
          }
        })
      }
      this.$emit('permissionChange', changedPermissions)
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~/assets/css/snui';

.permission-row {
  margin: 0;
}

::v-deep .v-expansion-panel-header {
  min-height: 32px !important;
}

::v-deep label {
  font-weight: 700 !important;
  font-size: 17px;
}

// Make disabled permissions clearly distinct from enabled ones: fainter label
// text, a more washed-out checkbox, and a not-allowed cursor on hover.
::v-deep .v-input--is-disabled {
  .v-label {
    opacity: 0.45;
  }

  .v-input--selection-controls__input {
    opacity: 0.4;
  }

  &,
  .v-input__slot,
  .v-input--selection-controls__input,
  .v-input--selection-controls__ripple,
  label,
  .v-label,
  .v-icon {
    cursor: not-allowed !important;
  }
}

::v-deep {
  &.v-input--selection-controls {
    padding-top: 0;
    margin-top: 12px;
    margin-bottom: 12px;
    height: 24px;
  }
}

.tooltip {
  margin: 0;
  padding-top: 8px;
  vertical-align: center;
}

</style>
